import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add Inspection
export const addSurvey = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/operations/app/v1/create-server`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("responsee", response);
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};
// delete Inspection
export const deleteSurvey = async (rowId) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/operations/app/v1/delete-servay/${rowId}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log("Error is - ", error);
    throw error;
  }
};
// total count
export const countSurvey = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/operations/app/v1/count-survey`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
// Get Inspection by ID
export const getSurveyById = async (rowId) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/operations/app/v1/get-servay-byid/${rowId}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
// update Survey
export const updateSurvey = async (rowId, data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/operations/app/v1/update-server/${rowId}`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fileUpload = async (data) => {
  const formDataToSend = new FormData();
  const file = data.attachment;
  const folderName = data.folderName;
  formDataToSend.append("file", file);
  formDataToSend.append("folderName", folderName);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/file/utils/app/v1/upload-media-file`, formDataToSend, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("responsefile", response);
    return response;
  } catch (error) {
    throw error;
  }
};
